import styled from 'styled-components';
import Flex from './Flex';
import {H1} from './Header';
import FadeSpinner from './FadeSpinner';

const FlexGrid = styled(Flex)`
  flex-wrap: wrap;
  justify-content: center;
`

function FlexList({data, status, error, Comp}) {

  if (status === 'loading') {
    return (
      <>
        <H1>Loading Products...</H1>
        <FadeSpinner/>
      </>
    )
  } else if (status === 'succeeded') {
    return (
      <FlexGrid>
        {
          data.map((item, index) => <Comp key={index} item={item}/>)
        }
      </FlexGrid>
    )
  } else if (status === 'failed') {
    return (
      <>
        <H1>Error loading products: {error}</H1>
      </>
    )
  }

  return <H1>Product loading status: {status}</H1>

}

export default FlexList